import {
  alpha,
  Autocomplete,
  Avatar,
  Box,
  Breadcrumbs,
  Button,
  Dialog,
  DialogContent,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputBase,
  Link,
  Menu,
  MenuItem,
  Pagination,
  Paper,
  Rating,
  Select,
  Skeleton,
  Stack,
  styled,
  SvgIcon,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import {
  BACK_ICON,
  IMG_COMMENT_ANALYTICS_ICON,
  IMG_DOWNLOAD_ANALYTICS_ICON,
  IMG_FORMS_ANALYTICS_ICON,
  IMG_LIKE_ANALYTICS_ICON,
  IMG_RESPONSE_ANALYTICS_ICON,
  IMG_RESPONSE_TIME_ANALYTICS_ICON,
  IMG_SHARE_ANALYTICS_ICON,
  IMG_VIEW_ANALYTICS_ICON
} from '../../utils/imageUrls';
import { Chart } from 'react-google-charts';
import {
  colorLinkGrey,
  colorMidGray,
  colorPrimary,
  colorSecondary,
  colorTextBlack,
  colorTextGrey
} from '../../config/theme';
import { useEffect, useState } from 'react';
import {
  Calendar01Icon,
  ChevronRightIcon,
  Copy05Icon,
  Expand05Icon,
  FileDownload03Icon,
  FilterLinesIcon,
  ShareThreeDotsIcon,
  XClose
} from '../../utils/iconSvg';
import {
  getContentAnalytics,
  getContentAnalyticsLogsById,
  getContentAnalyticsTableList,
  getContentCreatedByData,
  getFlowsAndFormsAnalytics,
  getFlowsAndFormsAnalyticsDetail,
  revertFlowsAndFormsAnalytics,
  revertUserAndRoleAnalytics
} from '../../redux/reducers/analyticsSlice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import {
  convertBarChartData,
  copyToClipboard,
  createTitle,
  handleError,
  isArrayNotEmpty
} from '../../utils/utils';
import { DragIndicator, East, HighlightOff } from '@mui/icons-material';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CustomDataTable from '../../components/CustomDataTable';
import moment from 'moment';
import { analyticsTypeHeaderContent } from '../../pages/ProductAnalysis';
import CustomPagination from '../../components/CustomTablePagination';
import _, { initial } from 'lodash';
import SnackBarBox from '../../components/SnackBarBox';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import ContentCards from '../Resources/ContentCards';
import ContentAnalyticsCard from '../Resources/ContentAnalyticsCard';
import html2canvas from 'html2canvas';

const StyledSelect = styled(Select)(({ theme }) => ({
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center'
  },
  '& .MuiMenuItem-root': {
    '& .MuiSvgIcon-root': {
      fontSize: 18,
      color: theme.palette.text.secondary,
      marginRight: theme.spacing(1.5)
    },
    '&:active': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        theme.palette.action.selectedOpacity
      )
    }
  }
}));

// List view component
export const ListView = ({
  name = '',
  flowId = '',
  formId = '',
  responseCount = '',
  onClick
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        height: '40px',
        cursor: 'pointer',
        padding: '4px 12px',
        width: '100%',
        display: 'flex',
        border: '1px solid #E4E7EB',
        borderRadius: '4px',
        alignItems: 'center',
        marginTop: '5px',
        justifyContent: 'space-between',
        wordBreak: 'break-all', // Breaks long words and strings
        whiteSpace: 'normal',
        backgroundColor: isHovered ? colorSecondary : 'transparent'
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          justifyContent: 'space-between'
        }}
        onClick={() => onClick({ flowId: flowId, formId: formId })}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <DragIndicator
            sx={{
              color: '#E4E7EB',
              marginRight: 1
            }}
          />

          {/* <a
              style={{ cursor: 'pointer' }}
              onClick={() => onClick({ flowId: flowId, formId: formId })}
            > */}
          <Typography fontWeight={'600'} color="#1F2933">
            {name}
          </Typography>
        </div>
        <Typography fontWeight={'600'} color={'#4E565F'}>
          {responseCount} Responses
        </Typography>
      </div>
      {/* </a> */}
    </div>
  );
};

// Chart view component
const ChartViewComponent = ({
  sr,
  questionId = null,
  questionText = '',
  responseCount = '',
  chartType = null,
  rating = 0,
  chartData = null
}) => {
  return (
    <Grid
      item
      width={'100%'}
      padding={'8px 8px'}
      mb={2}
      component={Paper}
      elevation={0}
      borderRadius={'8px'}
    >
      <Grid container display={'flex'} justifyContent={'space-between'}>
        <Typography fontWeight={'700'} fontSize="20px">
          <span
            style={{
              padding: '0.5rem 0.5rem 0.5rem 0.0rem',
              display: 'inline-flex',
              alignItems: 'center'
            }}
          >
            {sr + 1}{' '}
            <East
              fontSize="small"
              sx={{
                marginLeft: '4px'
              }}
            />
          </span>{' '}
          {questionText || ''}
        </Typography>

        {rating !== 0 && (
          <Box>
            <Typography variant="subtitle2" color={colorMidGray}>
              Average rating
            </Typography>{' '}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%'
              }}
            >
              <Typography
                sx={{ flex: 1, textAlign: 'center' }}
                fontSize="16px"
                fontWeight={'700'}
              >
                {rating ? parseFloat(rating).toFixed(1) : ''}
              </Typography>
              <Divider sx={{ mx: 1 }} orientation="vertical" flexItem />
              <Box sx={{ flex: 2 }}>
                <Rating size="small" precision={0.5} readOnly value={rating} />
              </Box>
            </Box>
          </Box>
        )}
      </Grid>
      <Divider sx={{ marginY: 1 }} />
      {responseCount !== 0 && (
        <Typography fontSize={'16px'} fontWeight={'700'}>
          {responseCount} Responses
        </Typography>
      )}
      <Grid mt={2} width={'100%'}>
        {chartType == 1 && chartData?.analyticsData && (
          <Chart
            chartType="PieChart"
            data={chartData?.analyticsData}
            options={{
              slices: {
                0: { color: '#2F68C4' },
                1: { color: colorPrimary },
                2: { color: '#749E35' }
              }
            }}
          />
        )}
        {(chartType == 2 || chartType == 3) && chartData?.analyticsData && (
          <Chart
            chartType="BarChart"
            data={convertBarChartData(chartData?.analyticsData)}
            options={{
              hAxis: {
                minValue: 0
              },
              legend: { position: 'none' },
              annotations: {
                alwaysOutside: true,
                textStyle: {
                  fontSize: 12,
                  auraColor: 'none',
                  color: '#555'
                }
              }
            }}
          />
        )}
        {!_.includes([1, 2, 3], chartType) && (
          <>
            <Box
              sx={{
                overflowY: 'auto',
                maxHeight: 'calc(100vh - 470px)',
                '&::-webkit-scrollbar': {
                  width: '0.2em'
                },
                '&::-webkit-scrollbar-track': {
                  background: '#E4E7EB'
                },
                '&::-webkit-scrollbar-thumb': {
                  background: 'rgba(0, 0, 0, 0.3)'
                },
                paddingX: 1
              }}
            >
              {isArrayNotEmpty(chartData) &&
                chartData.map((cc, idx) => {
                  return (
                    <div
                      key={idx}
                      style={{
                        padding: '4px 12px',
                        width: '100%',
                        display: 'flex',
                        border: '1px solid #E4E7EB',
                        borderRadius: '4px',
                        alignItems: 'center',
                        marginTop: idx != 0 ? '5px' : 0,
                        justifyContent: 'space-between',
                        wordBreak: 'break-all',
                        whiteSpace: 'normal',
                        backgroundColor: '#F5F7FA'
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                          justifyContent: 'space-between'
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          <Typography fontWeight={'600'} color="#1F2933">
                            {cc}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </Box>
          </>
        )}
      </Grid>
    </Grid>
  );
};

const styledMenuItem = {
  border: '1px solid #E4E7EB',
  background: 'inherit',
  marginX: 1,
  borderRadius: 3,
  fontWeight: 700,
  marginY: 1,
  justifyContent: 'center'
};

// Tile count component
export const TileCountComponent = ({
  count,
  description,
  icon,
  index,
  isSelected,
  onClick,
  clickable
}) => {
  return (
    <Grid
      item
      sx={{
        padding: '12px 15px',
        border: '1px solid #E4E7EB',
        borderRadius: '8px',
        width: '200px',
        display: 'flex',
        alignItems: 'center',
        cursor: clickable ? 'pointer' : 'default',
        backgroundColor: isSelected ? '#FCEBC5' : 'white',
        transition: 'all 0.3s ease-in-out'
      }}
      // mb={1}
      onClick={() => clickable && onClick(index)} // Handle selection
    >
      <Grid item mr={1}>
        <Avatar src={icon} sx={{ height: 48, width: 48 }} variant="rounded" />
      </Grid>
      <Grid item>
        <Typography fontSize={'32px'} lineHeight={'36px'} fontWeight={'700'}>
          {count}
        </Typography>
        <Typography fontWeight={'500'} fontSize={'14px'} color={'#4E565F'}>
          {description}
        </Typography>
      </Grid>
    </Grid>
  );
};

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,

  marginLeft: 0,
  marginRight: 10,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto'
  }
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  // padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  right: 6,
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

let searchValue = '';
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 1.5),
    paddingRight: `calc(1em + ${theme.spacing(2)})`,
    transition: theme.transitions.create('width'),
    width: searchValue ? '25ch' : '0px',
    [theme.breakpoints.up('sm')]: {
      '&:focus': {
        width: searchValue ? '25ch' : '25ch',
        border: '1px solid #CBD2D9',
        borderRadius: '8px'
      }
    }
  }
}));

export function prepareChartOptionsAndData(payload) {
  const data = payload.slice(1); // Remove header row

  const months = data.map(item => item[0]);
  const viewCounts = data.map(item => item[1]);
  const likeCounts = data.map(item => item[2]);
  const commentCounts = data.map(item => item[3]);
  const shareCounts = data.map(item => item[4]);
  const downloadCounts = data.map(item => item[5]);

  const maxViewCount = Math.max(...viewCounts);
  const maxLikeCount = Math.max(...likeCounts);
  const maxCommentCount = Math.max(...commentCounts);
  const maxShareCount = Math.max(...shareCounts);
  const maxDownloadCount = Math.max(...downloadCounts);

  const maxCount =
    Math.max(
      maxViewCount,
      maxLikeCount,
      maxCommentCount,
      maxShareCount,
      maxDownloadCount
    ) || 5;

  const ticks = [];
  for (
    let i = 0;
    i <= maxCount;
    i += maxCount == 0 ? 10 : maxCount <= 5 ? 1 : 10
  ) {
    ticks.push(i);
  }
  return ticks;
}

const ContentAnalytics = () => {
  const dispatch = useDispatch();
  const [char1, setChart1] = useState(null);
  const [tempDateFilter, setTempDateFilter] = useState({
    dateType: 'Month',
    startDate: null,
    endDate: null
  });
  const [anchorEl, setAnchorEl] = useState({ anchor: null, id: null });
  const [chart, setChart] = useState('');
  const [open, setOpen] = useState(null);
  const [formListPayload, setFormListPayload] = useState({
    tab: 0,
    size: 10,
    page: 0
  });
  const [copySuccess, setCopySuccess] = useState(false);
  const [localFormList, setLocalFormList] = useState([]);
  const [contentDetails, setContentDetails] = useState(null);
  const [showContentDetailAnalytics, setShowContentDetailAnalytics] =
    useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [chart1Payload, setChart1Payload] = useState({
    dateType: 'all',
    startDate: null,
    endDate: null
  });
  const [initialValues, setInitalValues] = useState({
    tabValue: 0,
    page: 0,
    size: 10,
    searchFilter: ''
  });

  const [contentByIdPayload, setContentByIdPayload] = useState({
    tabValue: 0,
    page: 0,
    size: 10,
    logsType: 'views'
  });

  const [openCalenderModal, setOpenCalendarModal] = useState({
    startDate: false,
    endDate: false
  });
  const [contentBy, setContentBy] = useState('');
  const [contentType, setContentType] = useState(null);
  const { authData } = useSelector(state => state.auth);
  const {
    isContentAnalyticsLoading,
    isContentAnalyticsFailed,
    contentAnalyticsErrorContainer,
    contentAnalyticsData,
    analyticsContentList,
    contentAnalyticsLogData,
    contentCreatedByData
  } = useSelector(state => state.analytics);

  useEffect(() => {
    createTitle('Content Analytics');
    const payload = {
      paginationRequest: {
        type: 'all',
        page: initialValues.page,
        size: initialValues.size
      }
    };
    dispatch(
      getContentAnalyticsTableList({
        payload,
        search: initialValues.searchFilter
      })
    );
    return () => {
      // dispatch(revertFlowsAndFormsAnalytics());
    };
  }, [initialValues]);

  useEffect(() => {
    dispatch(getContentCreatedByData());
  }, []);

  useEffect(() => {
    let payload = {
      contentId: contentDetails?.contentId ?? null,
      contentType: contentType?.id ?? null,
      contentBy: contentBy || null,
      dateType: chart1Payload.dateType == 'all' ? null : chart1Payload.dateType,
      startDate: chart1Payload.startDate
        ? dayjs(chart1Payload.startDate).format('YYYY-MM-DD')
        : null,
      endDate: chart1Payload.endDate
        ? dayjs(chart1Payload.endDate).format('YYYY-MM-DD')
        : null
    };
    dispatch(getContentAnalytics(payload));
  }, [
    chart1Payload,
    contentDetails,
    contentType,
    contentBy,
    showContentDetailAnalytics
  ]);

  const logsTypeMapping = ['views', 'likes', 'comments', 'shares', 'downloads'];

  useEffect(() => {
    createTitle('Content Analytics');
    const payload = {
      contentId: contentDetails?.contentId,
      startDate: null,
      endDate: null,
      dateType: null,
      logsType: contentByIdPayload.logsType,
      paginationRequest: {
        page: contentByIdPayload.page,
        size: contentByIdPayload.size,
        type: 'all'
      }
    };
    dispatch(getContentAnalyticsLogsById(payload));
    return () => {
      // dispatch(revertFlowsAndFormsAnalytics());
    };
  }, [contentByIdPayload, contentDetails]);

  const seriesNames = contentAnalyticsData?.analyticsData[0]?.slice(1) || [];

  const [visibleSeries, setVisibleSeries] = useState({});

  useEffect(() => {
    if (seriesNames.length > 0 && Object.keys(visibleSeries).length === 0) {
      setVisibleSeries(
        seriesNames.reduce((acc, _, index) => {
          acc[index] = true; // ✅ Set visibility only on first render
          return acc;
        }, {})
      );
    }
  }, [seriesNames]);

  const toggleSeries = index => {
    setVisibleSeries(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const colors = ['#EA7804', '#2F68C4', colorPrimary, '#749E35', '#6530CD'];

  const handleTileClick = index => {
    setSelectedIndex(index);
    setContentByIdPayload(prev => ({
      ...prev,
      logsType: logsTypeMapping[index],
      page: 0
    }));
  };

  const handleClickOpen = id => {
    setChart(id);
  };

  const handleClose = () => {
    setChart('');
  };

  const handleOpenCalendar = type => {
    setOpenCalendarModal({ ...openCalenderModal, [type]: true });
  };

  const handleCloseCalendar = type => {
    setOpenCalendarModal({ ...openCalenderModal, [type]: false });
  };

  const handleShareClick = (event, id) => {
    setAnchorEl({ anchor: event.currentTarget, id: id });
  };

  const handleShareClose = () => {
    setAnchorEl({ anchor: null, id: null });
    setTimeout(() => {
      setCopySuccess(false);
    }, 4000);
  };

  const handleCopyLink = id => {
    let ids = {
      1: 'contentAnalyticsChart'
    };
    let chart1dateTime = `&startDate=${
      chart1Payload.startDate
        ? dayjs(chart1Payload.startDate).format('YYYY-MM-DD')
        : null
    }&endDate=${
      chart1Payload.endDate
        ? dayjs(chart1Payload.endDate).format('YYYY-MM-DD')
        : null
    }`;
    let chart1ExtraLink = `&dateType=${chart1Payload.dateType}${chart1Payload.dateType === 'selected_date' ? chart1dateTime : ''}&contentId=${contentDetails?.contentId ?? null}&contentType=${contentType?.id ?? null}&contentBy=${contentBy ?? null}`;

    let shareLink = `${process.env.REACT_APP_PORTAL_URL}share-charts?chartType=${ids[id]}${chart1ExtraLink}`;

    navigator.clipboard.writeText(shareLink);
    console.log('shareLink', shareLink);
    copyToClipboard(shareLink);
    setCopySuccess(true);
    handleShareClose();
  };

  const columns = [
    {
      uniqueKey: 'contentId',
      id: 'title',
      label: 'Most viewed',
      sortable: true,
      width: '850px',
      render: row => {
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <ContentAnalyticsCard contentData={row} />
          </Box>
        );
      }
    },
    {
      id: 'views',
      label: 'Views'
    }
  ];

  const columnUsers = [
    {
      uinqueKey: 'created_dt',
      id: 'created_dt',
      label: 'Users',
      sortable: true,
      minWidth: '100px',
      render: row => (
        <>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {row.profileImageUrl ? (
              <Avatar
                src={row.profileImageUrl}
                alt={row.name}
                sx={{ width: 25, height: 25, marginRight: 1 }}
              />
            ) : (
              <Avatar
                sx={{
                  width: 25,
                  height: 25,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#c9c9c9',
                  color: 'white',
                  fontSize: '12px',
                  marginRight: '5px'
                }}
              >
                {row ? row.name?.split(' ')[0]?.charAt(0).toUpperCase() : ''}
              </Avatar>
            )}

            <Typography variant="body2" fontWeight={'600'}>
              {row.name}
            </Typography>
          </div>
        </>
      )
    },
    {
      id: 'schoolName',
      label: 'School Name'
    },
    {
      id: 'grade',
      label: 'Grade'
    },
    {
      id: 'created_dt',
      label: 'Time',
      minWidth: '150px',
      render: row => {
        return (
          <>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="body2" fontWeight={'600'}>
                {row.created_dt
                  ? moment(row.created_dt)
                      .format('DD/MM/YYYY, h:mmA')
                      .toLowerCase()
                  : 'NA'}
              </Typography>
            </div>
          </>
        );
      }
    }
  ];

  const options = {
    hAxis: {
      title: 'Month',
      titleTextStyle: {
        fontSize: 14,
        color: '#ABB4BD',
        italic: false,
        bold: true
      }
    },
    vAxis: {
      title: 'Count',
      titleTextStyle: {
        fontSize: 14,
        color: '#ABB4BD',
        italic: false,
        bold: true
      },
      viewWindow: {
        min: 0
      },
      ticks: prepareChartOptionsAndData(contentAnalyticsData.analyticsData),
      gridlines: {
        count: 10,
        color: '#F5F7FA',
        units: {
          ones: { count: 0 }
        }
      }
    },
    curveType: 'function',
    series:
      seriesNames.length > 0
        ? seriesNames.reduce((acc, _, index) => {
            acc[index] = {
              color: colors[index] || '#000',
              lineWidth: visibleSeries[index] ? 2 : 0,
              pointSize: visibleSeries[index] ? 5 : 0
            };
            return acc;
          }, {})
        : {},
    legend: { position: 'none' }
  };

  const tiles = [
    {
      icon: IMG_VIEW_ANALYTICS_ICON,
      count: contentAnalyticsData.totalViewsCount || 0,
      description: 'Views'
    },
    {
      icon: IMG_LIKE_ANALYTICS_ICON,
      count: contentAnalyticsData.totalLikesCount || 0,
      description: 'Likes'
    },
    {
      icon: IMG_COMMENT_ANALYTICS_ICON,
      count: contentAnalyticsData.totalCommentsCount || 0,
      description: 'Comments'
    },
    {
      icon: IMG_SHARE_ANALYTICS_ICON,
      count: contentAnalyticsData.totalSharesCount || 0,
      description: 'Shares'
    },
    {
      icon: IMG_DOWNLOAD_ANALYTICS_ICON,
      count: contentAnalyticsData.totalDownloadsCount || 0,
      description: 'Downloads'
    }
  ];

  // const handleDownload = ({ id = null }) => {
  //   if (id) {
  //     const chartWrapper = id === 1 && char1;
  //     const imageURI = chartWrapper.getChart().getImageURI();
  //     const link = document.createElement('a');
  //     link.href = imageURI;
  //     link.download = 'chart.png';
  //     link.click();
  //   }
  // };

  const handleDownload = async ({ id = null }) => {
    const container = document.getElementById(`chart-container-${id}`);
    if (!container) return;

    const canvas = await html2canvas(container, {
      ignoreElements: element => {
        return element.classList.contains('exclude-from-download');
      }
    });

    const image = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = image;
    link.download = 'chart.png';
    link.click();
  };

  function getOptionLabel(option) {
    if (!option) {
      return '';
    }

    if (option.label !== null) {
      return option.label;
    }

    return '';
  }

  const debouncedSearch = _.debounce(
    term => setInitalValues({ ...initialValues, searchFilter: term, page: 0 }),
    300
  );

  const handleSearch = e => {
    const term = e.target.value;
    // setSearch(term);
    if (term.length >= 3 || term.length === 0) {
      debouncedSearch(term);
    }
  };

  return (
    <>
      {!showContentDetailAnalytics && (
        <>
          <Typography mb={2} fontSize={'32px'} fontWeight={'700'}>
            {analyticsTypeHeaderContent['content']}
          </Typography>
          {/* Count tiles */}
          <Grid
            container
            component={Paper}
            elevation={0}
            sx={{
              borderRadius: '8px',
              padding: 1.5,
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between'
            }}
          >
            <TileCountComponent
              icon={IMG_VIEW_ANALYTICS_ICON}
              count={contentAnalyticsData.totalViewsCount || 0}
              description={'Views'}
            />
            <TileCountComponent
              icon={IMG_LIKE_ANALYTICS_ICON}
              count={contentAnalyticsData.totalLikesCount || 0}
              description={'Likes'}
            />
            <TileCountComponent
              icon={IMG_COMMENT_ANALYTICS_ICON}
              count={contentAnalyticsData.totalCommentsCount || 0}
              description={'Comments'}
            />
            <TileCountComponent
              icon={IMG_SHARE_ANALYTICS_ICON}
              count={contentAnalyticsData.totalSharesCount || 0}
              description={'Shares'}
            />
            <TileCountComponent
              icon={IMG_DOWNLOAD_ANALYTICS_ICON}
              count={contentAnalyticsData.totalDownloadsCount || 0}
              description={'Downloads'}
            />
          </Grid>

          {/* Chart */}
          <Grid
            mt={2}
            container
            display={'flex'}
            width={'100%'}
            flexDirection={'column'}
            sx={{ borderRadius: '8px', padding: 2, bgcolor: 'white' }}
          >
            <Grid
              item
              xs={12}
              display={'flex'}
              justifyContent={'space-between'}
              mb={1}
              width={'100%'}
            >
              <Box display={'flex'} width={'740px'}>
                <Box sx={{ width: '224px' }} marginRight={'8px'}>
                  <FormControl fullWidth sx={{ marginRight: 1 }}>
                    <Autocomplete
                      size="small"
                      value={contentBy}
                      onChange={(event, newValue) => {
                        setContentBy(newValue);
                      }}
                      // getOptionLabel={getOptionLabel}
                      disableClearable
                      isOptionEqualToValue={(option, value) => option === value}
                      options={contentCreatedByData}
                      renderInput={params => (
                        <TextField
                          // name="contentType"
                          {...params}
                          placeholder="Select content by"
                        />
                      )}
                      ListboxProps={{
                        sx: {
                          '& .MuiAutocomplete-option:hover': {
                            backgroundColor: colorSecondary
                          }
                        }
                      }}
                    />
                  </FormControl>
                </Box>
                <Box sx={{ width: '224px' }} marginRight={'8px'}>
                  <FormControl fullWidth sx={{ marginRight: 1 }}>
                    <Autocomplete
                      size="small"
                      value={contentType}
                      onChange={(event, newValue) => {
                        setContentType(newValue);
                      }}
                      getOptionLabel={getOptionLabel}
                      disableClearable
                      isOptionEqualToValue={(option, value) => option === value}
                      options={[
                        { label: 'All', id: 'All' },
                        { label: 'Registered', id: 'Registered' },
                        { label: 'PAF only', id: 'PAF only' }
                        // { label: 'Free', id: 'Free' }
                      ]}
                      renderInput={params => (
                        <TextField
                          // name="contentType"
                          {...params}
                          placeholder="Select content type"
                        />
                      )}
                      ListboxProps={{
                        sx: {
                          '& .MuiAutocomplete-option:hover': {
                            backgroundColor: colorSecondary
                          }
                        }
                      }}
                    />
                  </FormControl>
                </Box>
                <Box sx={{ width: '296px' }} marginRight={'8px'}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    // sx={{ width: '296px' }}
                    size="small"
                  >
                    <StyledSelect
                      IconComponent={Calendar01Icon}
                      size="small"
                      open={open == 1}
                      value={
                        open == 1
                          ? tempDateFilter.dateType
                          : chart1Payload.dateType
                      }
                      onOpen={(e, va) => {
                        setOpen(1);
                        setTempDateFilter({
                          dateType: chart1Payload.dateType,
                          startDate: chart1Payload.startDate,
                          endDate: chart1Payload.endDate
                        });
                      }}
                      onChange={e => {
                        setTempDateFilter({
                          ...tempDateFilter,
                          dateType: e.target.value,
                          startDate: null,
                          endDate: null
                        });
                      }}
                      renderValue={value => {
                        let data = open === 1 ? tempDateFilter : chart1Payload;
                        if (data.dateType === 'all') {
                          return (
                            <Typography
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                color: '#ABB4BD'
                              }}
                            >
                              <SvgIcon fontSize="small" sx={{ marginRight: 1 }}>
                                <FilterLinesIcon color="#ABB4BD" />
                              </SvgIcon>
                              Select date
                            </Typography>
                          );
                        }
                        switch (data.dateType) {
                          case 'selected_date':
                            return `${data.startDate ? dayjs(data.startDate).format('DD/MM/YY') : ''} - ${data.endDate ? dayjs(data.endDate).format('DD/MM/YY') : ''}`;
                          case 'Week':
                            return 'Last Week';
                          case 'Month':
                            return 'This Month';
                          case 'past_3_months':
                            return 'Past 3 months';
                          case 'Past_1_Year':
                            return 'Past 1 year';
                          default:
                            return 'Select date';
                        }
                      }}
                      // endAdornment={
                      //   chart1Payload.dateType ? (
                      //     <IconButton
                      //       sx={{ marginRight: '10px' }}
                      //       aria-label="clear"
                      //       size="small"
                      //       onClick={() => {
                      //         setChart1Payload({
                      //           ...chart1Payload,
                      //           dateType: 'Month',
                      //           startDate: null,
                      //           endDate: null
                      //         });
                      //         setTempDateFilter({
                      //           startDate: null,
                      //           dateType: 'Month',
                      //           endDate: null
                      //         });
                      //       }}
                      //       edge="end"
                      //     >
                      //       <HighlightOff sx={{ color: '#ABB4BD' }} />
                      //     </IconButton>
                      //   ) : null
                      // }
                      sx={{
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#CBD2D9'
                        },
                        '&:hover  .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#CBD2D9'
                        },
                        '&.Mui-focused  .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#CBD2D9'
                        },
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 8
                        }
                      }}
                    >
                      <MenuItem
                        sx={{ ...styledMenuItem, paddingX: 0, border: 'none' }}
                        value="selected_date"
                        disableRipple
                      >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Box display={'flex'} margin={'0px 6px'}>
                            <FormControl
                              variant="outlined"
                              // fullWidth
                              sx={{ width: '185px' }}
                              size="small"
                            >
                              <Typography
                                sx={{
                                  fontSize: '14px',
                                  fontWeight: 600,
                                  mb: 0.5
                                }}
                              >
                                Start Date
                              </Typography>
                              <DatePicker
                                // name="Start-Date"
                                maxDate={dayjs()}
                                sx={{ marginRight: 1 }}
                                value={dayjs(tempDateFilter.startDate)}
                                onOpen={() => handleOpenCalendar('startDate')}
                                onClose={() => handleCloseCalendar('startDate')}
                                open={openCalenderModal.startDate}
                                format="DD/MM/YYYY"
                                slotProps={{
                                  textField: {
                                    size: 'small',
                                    error: false,
                                    InputProps: {
                                      sx: { color: colorTextBlack },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <IconButton
                                            size="small"
                                            onClick={() =>
                                              handleOpenCalendar('startDate')
                                            }
                                          >
                                            <Calendar01Icon />
                                          </IconButton>
                                        </InputAdornment>
                                      )
                                    }
                                  }
                                }}
                                onChange={date =>
                                  setTempDateFilter({
                                    ...tempDateFilter,
                                    dateType: 'selected_date',
                                    startDate: date,
                                    endDate: date
                                  })
                                }
                                components={{ OpenPickerIcon: () => null }}
                                // components={{
                                //   OpenPickerIcon: props => (
                                //     <IconButton size="small" {...props}>
                                //       <Calendar01Icon />
                                //     </IconButton>
                                //   )
                                // }}
                              />
                            </FormControl>
                            <FormControl
                              variant="outlined"
                              sx={{ width: '185px' }}
                              // fullWidth
                              size="small"
                            >
                              <Typography
                                sx={{
                                  fontSize: '14px',
                                  fontWeight: 600,
                                  mb: 0.5
                                }}
                              >
                                End Date
                              </Typography>
                              <DatePicker
                                maxDate={dayjs()}
                                minDate={dayjs(tempDateFilter.startDate)}
                                // label="End Date"
                                value={dayjs(tempDateFilter.endDate)}
                                open={openCalenderModal.endDate}
                                onOpen={() => handleOpenCalendar('endDate')}
                                onClose={() => handleCloseCalendar('endDate')}
                                format="DD/MM/YYYY"
                                slotProps={{
                                  textField: {
                                    size: 'small',
                                    error: false,
                                    InputProps: {
                                      sx: { color: colorTextBlack },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <IconButton
                                            size="small"
                                            onClick={() =>
                                              handleOpenCalendar('endDate')
                                            }
                                          >
                                            <Calendar01Icon />
                                          </IconButton>
                                        </InputAdornment>
                                      )
                                    }
                                  }
                                }}
                                onChange={date => {
                                  setTempDateFilter({
                                    ...tempDateFilter,
                                    dateType: 'selected_date',
                                    endDate: date
                                  });
                                }}
                                components={{ OpenPickerIcon: () => null }}
                                // components={{
                                //   OpenPickerIcon: props => (
                                //     <IconButton size="small" {...props}>
                                //       <Calendar01Icon />
                                //     </IconButton>
                                //   )
                                // }}
                              />
                            </FormControl>
                          </Box>
                        </LocalizationProvider>
                      </MenuItem>

                      <MenuItem sx={styledMenuItem} value="Week" disableRipple>
                        Last Week
                      </MenuItem>
                      <MenuItem sx={styledMenuItem} value="Month" disableRipple>
                        Current Month
                      </MenuItem>
                      <MenuItem
                        sx={styledMenuItem}
                        value="past_3_months"
                        disableRipple
                      >
                        Past 3 month
                      </MenuItem>
                      <MenuItem
                        sx={styledMenuItem}
                        value="Past_1_Year"
                        disableRipple
                      >
                        Past 1 year
                      </MenuItem>
                      <MenuItem
                        sx={{
                          border: '1px solid #E4E7EB',
                          backgroundColor: colorPrimary,
                          marginX: 1,
                          borderRadius: 3,
                          fontWeight: 700,
                          justifyContent: 'center',
                          marginY: 1,
                          '&:hover': {
                            background: colorPrimary
                          }
                        }}
                        onClick={() => {
                          if (tempDateFilter.dateType) {
                            setChart1Payload({
                              ...chart1Payload,
                              dateType: tempDateFilter.dateType,
                              startDate: tempDateFilter.startDate,
                              endDate: tempDateFilter.endDate
                            });
                          }
                          setTempDateFilter({
                            dateType: null,
                            endDate: null,
                            startDate: null
                          });
                          setOpen(null);
                        }}
                      >
                        Apply
                      </MenuItem>
                      <MenuItem
                        // disabled={
                        //   !(tempDateFilter.dateType || chart1Payload.dateFilter)
                        // }
                        sx={{
                          border: '1px solid #E4E7EB',
                          backgroundColor: colorPrimary,
                          marginX: 1,
                          borderRadius: 3,
                          fontWeight: 700,
                          justifyContent: 'center',
                          marginY: 1,
                          '&:hover': {
                            background: colorPrimary
                          }
                        }}
                        onClick={() => {
                          setChart1Payload({
                            ...chart1Payload,
                            dateType: 'all',
                            startDate: null,
                            endDate: null
                          });
                          setTempDateFilter({
                            startDate: null,
                            dateType: null,
                            endDate: null
                          });
                          setOpen(null);
                        }}
                      >
                        Close
                      </MenuItem>
                    </StyledSelect>
                  </FormControl>
                </Box>
              </Box>
              <Grid item sx={{ display: 'flex', alignSelf: 'end' }}>
                <Tooltip title="Resize">
                  <IconButton
                    onClick={() => handleClickOpen(1)}
                    sx={{ mx: 0.5 }}
                  >
                    <SvgIcon sx={{ height: 20, width: 20 }}>
                      <Expand05Icon />
                    </SvgIcon>
                  </IconButton>{' '}
                </Tooltip>
                <Tooltip title="Download image">
                  <IconButton
                    onClick={() => {
                      handleDownload({ id: 1 });
                    }}
                    sx={{ mr: 0.5 }}
                  >
                    <SvgIcon sx={{ height: 20, width: 20 }}>
                      <FileDownload03Icon />
                    </SvgIcon>
                  </IconButton>
                </Tooltip>
                <Tooltip title="Share">
                  <IconButton onClick={e => handleShareClick(e, 1)}>
                    <SvgIcon sx={{ height: 20, width: 20 }}>
                      <ShareThreeDotsIcon />
                    </SvgIcon>
                  </IconButton>{' '}
                </Tooltip>

                <Menu
                  anchorEl={anchorEl.anchor}
                  open={Boolean(anchorEl.id == 1)}
                  onClose={handleShareClose}
                  onClick={handleShareClose}
                >
                  <MenuItem onClick={() => handleCopyLink(1)}>
                    <SvgIcon fontSize="small" sx={{ marginRight: 2 }}>
                      <Copy05Icon />
                    </SvgIcon>{' '}
                    Copy link
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
            {/* <Legend
              series={
                contentAnalyticsData.analyticsData.length > 0
                  ? contentAnalyticsData.analyticsData[0]
                      .slice(1)
                      .map((name, index) => ({
                        name,
                        color: options.series[index].color
                      }))
                  : []
              }
            /> */}
            <div id="chart-container-1" style={{ padding: 10 }}>
              <>
                <Legend
                  series={seriesNames.map((name, index) => ({
                    name,
                    color: colors[index],
                    isVisible: visibleSeries[index],
                    onClick: () => toggleSeries(index)
                  }))}
                />
                <Grid item xs={12}>
                  {isContentAnalyticsLoading && (
                    <Skeleton height={300} width={'100%'} />
                  )}
                  {!isContentAnalyticsLoading && (
                    <Chart
                      height={'300px'}
                      width={'100%'}
                      chartType="LineChart"
                      data={contentAnalyticsData.analyticsData}
                      options={options}
                      getChartWrapper={val => {
                        setChart1(val);
                      }}
                    />
                  )}{' '}
                </Grid>
              </>
            </div>
          </Grid>

          {/* List content */}
          <Grid
            mt={2}
            container
            display={'flex'}
            width={'100%'}
            flexDirection={'column'}
            sx={{ borderRadius: '8px', padding: 2, bgcolor: 'white' }}
          >
            <Box
              display={'flex'}
              justifyContent={'flex-end'}
              // flexDirection={'row-reverse'}
              alignItems={'center'}
              // margin="auto 10px"
              marginBottom={1.5}
            >
              <Search>
                <SearchIconWrapper>
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18 17.5L14.375 13.875M16.3333 9.16667C16.3333 12.8486 13.3486 15.8333 9.66667 15.8333C5.98477 15.8333 3 12.8486 3 9.16667C3 5.48477 5.98477 2.5 9.66667 2.5C13.3486 2.5 16.3333 5.48477 16.3333 9.16667Z"
                      stroke="#ABB4BD"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </SearchIconWrapper>
                <StyledInputBase
                  onChange={e => {
                    // searchValue = e.target.value;
                    handleSearch(e);
                  }}
                  placeholder="Search here…"
                />
              </Search>
            </Box>
            <CustomDataTable
              columns={columns}
              defaultOrderBy={'createdDate'}
              data={
                analyticsContentList?.contentList.length > 0
                  ? analyticsContentList?.contentList
                  : []
              }
              onPageChange={val => {
                setInitalValues({ ...initialValues, page: val });
              }}
              onRowsPerPageChange={val => {
                setInitalValues({ ...initialValues, size: val });
              }}
              defaultPage={initialValues.page}
              defaultRowsPerPage={initialValues.size}
              totalCount={analyticsContentList?.allCount ?? 0}
              onRowClick={row => {
                setShowContentDetailAnalytics(true);
                setContentDetails(row);
                setContentBy('');
                setContentType(null);
                setChart1Payload({
                  dateType: 'all',
                  startDate: null,
                  endDate: null
                });
                setVisibleSeries(
                  seriesNames.reduce((acc, _, index) => {
                    acc[index] = true; // ✅ Set visibility only on first render
                    return acc;
                  }, {})
                );
                // setTempDateFilter({
                //   dateType: 'Month',
                //   startDate: null,
                //   endDate: null
                // })
              }}
            />
          </Grid>
          {!isContentAnalyticsLoading && isContentAnalyticsFailed && (
            <SnackBarBox
              type="error"
              message={handleError(
                contentAnalyticsErrorContainer?.errorMessage
              )}
            />
          )}
        </>
      )}
      {/* Show all flow list on another page */}
      {showContentDetailAnalytics && (
        <>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '10px'
            }}
          >
            <SvgIcon
              sx={{ marginRight: 2, cursor: 'pointer' }}
              onClick={event => {
                event.preventDefault();
                setContentDetails(null);
                setContentBy('');
                setContentType(null);
                setChart1Payload({
                  dateType: 'all',
                  startDate: null,
                  endDate: null
                });
                setVisibleSeries(
                  seriesNames.reduce((acc, _, index) => {
                    acc[index] = true; // ✅ Set visibility only on first render
                    return acc;
                  }, {})
                );
                setShowContentDetailAnalytics(false);
              }}
            >
              {BACK_ICON}
            </SvgIcon>

            <Typography
              sx={{
                fontSize: '24px',
                fontWeight: '500',
                color: colorTextBlack
              }}
            >
              {contentDetails.title || ''}
            </Typography>
          </Box>

          {/* Count Tiles */}
          <Grid
            container
            component={Paper}
            elevation={0}
            sx={{
              borderRadius: '8px',
              padding: 1.5,
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between'
            }}
          >
            {tiles.map((tile, index) => (
              <TileCountComponent
                key={index}
                index={index}
                icon={tile.icon}
                count={tile.count}
                description={tile.description}
                clickable={true}
                isSelected={selectedIndex === index}
                onClick={handleTileClick}
              />
            ))}
          </Grid>

          {/* Chart */}
          <Grid
            mt={2}
            container
            display={'flex'}
            width={'100%'}
            flexDirection={'column'}
            sx={{ borderRadius: '8px', padding: 2, bgcolor: 'white' }}
          >
            <Grid
              item
              xs={12}
              display={'flex'}
              justifyContent={'space-between'}
              mb={1}
              width={'100%'}
            >
              <Box display={'flex'} width={'740px'}>
                {/* <Box sx={{ width: '224px' }} marginRight={'8px'}>
                  <FormControl fullWidth sx={{ marginRight: 1 }}>
                    <Autocomplete
                      size="small"
                      value={contentBy}
                      onChange={(event, newValue) => {
                        setContentBy(newValue);
                      }}
                      // getOptionLabel={getOptionLabel}
                      disableClearable
                      isOptionEqualToValue={(option, value) => option === value}
                      options={contentCreatedByData}
                      renderInput={params => (
                        <TextField
                          // name="contentType"
                          {...params}
                          placeholder="Select content by"
                        />
                      )}
                      ListboxProps={{
                        sx: {
                          '& .MuiAutocomplete-option:hover': {
                            backgroundColor: colorSecondary
                          }
                        }
                      }}
                    />
                  </FormControl>
                </Box>
                <Box sx={{ width: '224px' }} marginRight={'8px'}>
                  <FormControl fullWidth sx={{ marginRight: 1 }}>
                    <Autocomplete
                      size="small"
                      value={contentType}
                      onChange={(event, newValue) => {
                        setContentType(newValue);
                      }}
                      getOptionLabel={getOptionLabel}
                      disableClearable
                      isOptionEqualToValue={(option, value) => option === value}
                      options={[
                        { label: 'All', id: 'All' },
                        { label: 'Registered', id: 'Registered' },
                        { label: 'PAF only', id: 'PAF only' }
                        // { label: 'Free', id: 'Free' }
                      ]}
                      renderInput={params => (
                        <TextField
                          // name="contentType"
                          {...params}
                          placeholder="Select content type"
                        />
                      )}
                      ListboxProps={{
                        sx: {
                          '& .MuiAutocomplete-option:hover': {
                            backgroundColor: colorSecondary
                          }
                        }
                      }}
                    />
                  </FormControl>
                </Box> */}
                <Box sx={{ width: '296px' }} marginRight={'8px'}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    // sx={{ width: '296px' }}
                    size="small"
                  >
                    <StyledSelect
                      IconComponent={Calendar01Icon}
                      size="small"
                      open={open == 1}
                      value={
                        open == 1
                          ? tempDateFilter.dateType
                          : chart1Payload.dateType
                      }
                      onOpen={(e, va) => {
                        setOpen(1);
                        setTempDateFilter({
                          dateType: chart1Payload.dateType,
                          startDate: chart1Payload.startDate,
                          endDate: chart1Payload.endDate
                        });
                      }}
                      onChange={e => {
                        setTempDateFilter({
                          ...tempDateFilter,
                          dateType: e.target.value,
                          startDate: null,
                          endDate: null
                        });
                      }}
                      renderValue={value => {
                        let data = open === 1 ? tempDateFilter : chart1Payload;
                        if (data.dateType === 'all') {
                          return (
                            <Typography
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                color: '#ABB4BD'
                              }}
                            >
                              <SvgIcon fontSize="small" sx={{ marginRight: 1 }}>
                                <FilterLinesIcon color="#ABB4BD" />
                              </SvgIcon>
                              Select date
                            </Typography>
                          );
                        }
                        switch (data.dateType) {
                          case 'selected_date':
                            return `${data.startDate ? dayjs(data.startDate).format('DD/MM/YY') : ''} - ${data.endDate ? dayjs(data.endDate).format('DD/MM/YY') : ''}`;
                          case 'Week':
                            return 'Last Week';
                          case 'Month':
                            return 'This Month';
                          case 'past_3_months':
                            return 'Past 3 months';
                          case 'Past_1_Year':
                            return 'Past 1 year';
                          default:
                            return 'Select date';
                        }
                      }}
                      // endAdornment={
                      //   chart1Payload.dateType ? (
                      //     <IconButton
                      //       sx={{ marginRight: '10px' }}
                      //       aria-label="clear"
                      //       size="small"
                      //       onClick={() => {
                      //         setChart1Payload({
                      //           ...chart1Payload,
                      //           dateType: 'Month',
                      //           startDate: null,
                      //           endDate: null
                      //         });
                      //         setTempDateFilter({
                      //           startDate: null,
                      //           dateType: 'Month',
                      //           endDate: null
                      //         });
                      //       }}
                      //       edge="end"
                      //     >
                      //       <HighlightOff sx={{ color: '#ABB4BD' }} />
                      //     </IconButton>
                      //   ) : null
                      // }
                      sx={{
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#CBD2D9'
                        },
                        '&:hover  .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#CBD2D9'
                        },
                        '&.Mui-focused  .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#CBD2D9'
                        },
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 8
                        }
                      }}
                    >
                      <MenuItem
                        sx={{ ...styledMenuItem, paddingX: 0, border: 'none' }}
                        value="selected_date"
                        disableRipple
                      >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Box display={'flex'} margin={'0px 6px'}>
                            <FormControl
                              variant="outlined"
                              // fullWidth
                              sx={{ width: '185px' }}
                              size="small"
                            >
                              <Typography
                                sx={{
                                  fontSize: '14px',
                                  fontWeight: 600,
                                  mb: 0.5
                                }}
                              >
                                Start Date
                              </Typography>
                              <DatePicker
                                // name="Start-Date"
                                maxDate={dayjs()}
                                sx={{ marginRight: 1 }}
                                value={dayjs(tempDateFilter.startDate)}
                                onOpen={() => handleOpenCalendar('startDate')}
                                onClose={() => handleCloseCalendar('startDate')}
                                open={openCalenderModal.startDate}
                                format="DD/MM/YYYY"
                                slotProps={{
                                  textField: {
                                    size: 'small',
                                    error: false,
                                    InputProps: {
                                      sx: { color: colorTextBlack },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <IconButton
                                            size="small"
                                            onClick={() =>
                                              handleOpenCalendar('startDate')
                                            }
                                          >
                                            <Calendar01Icon />
                                          </IconButton>
                                        </InputAdornment>
                                      )
                                    }
                                  }
                                }}
                                onChange={date =>
                                  setTempDateFilter({
                                    ...tempDateFilter,
                                    dateType: 'selected_date',
                                    startDate: date,
                                    endDate: date
                                  })
                                }
                                components={{ OpenPickerIcon: () => null }}
                                // components={{
                                //   OpenPickerIcon: props => (
                                //     <IconButton size="small" {...props}>
                                //       <Calendar01Icon />
                                //     </IconButton>
                                //   )
                                // }}
                              />
                            </FormControl>
                            <FormControl
                              variant="outlined"
                              sx={{ width: '185px' }}
                              // fullWidth
                              size="small"
                            >
                              <Typography
                                sx={{
                                  fontSize: '14px',
                                  fontWeight: 600,
                                  mb: 0.5
                                }}
                              >
                                End Date
                              </Typography>
                              <DatePicker
                                maxDate={dayjs()}
                                minDate={dayjs(tempDateFilter.startDate)}
                                // label="End Date"
                                value={dayjs(tempDateFilter.endDate)}
                                open={openCalenderModal.endDate}
                                onOpen={() => handleOpenCalendar('endDate')}
                                onClose={() => handleCloseCalendar('endDate')}
                                format="DD/MM/YYYY"
                                slotProps={{
                                  textField: {
                                    size: 'small',
                                    error: false,
                                    InputProps: {
                                      sx: { color: colorTextBlack },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <IconButton
                                            size="small"
                                            onClick={() =>
                                              handleOpenCalendar('endDate')
                                            }
                                          >
                                            <Calendar01Icon />
                                          </IconButton>
                                        </InputAdornment>
                                      )
                                    }
                                  }
                                }}
                                onChange={date => {
                                  setTempDateFilter({
                                    ...tempDateFilter,
                                    dateType: 'selected_date',
                                    endDate: date
                                  });
                                }}
                                components={{ OpenPickerIcon: () => null }}
                                // components={{
                                //   OpenPickerIcon: props => (
                                //     <IconButton size="small" {...props}>
                                //       <Calendar01Icon />
                                //     </IconButton>
                                //   )
                                // }}
                              />
                            </FormControl>
                          </Box>
                        </LocalizationProvider>
                      </MenuItem>

                      <MenuItem sx={styledMenuItem} value="Week" disableRipple>
                        Last Week
                      </MenuItem>
                      <MenuItem sx={styledMenuItem} value="Month" disableRipple>
                        Current Month
                      </MenuItem>
                      <MenuItem
                        sx={styledMenuItem}
                        value="past_3_months"
                        disableRipple
                      >
                        Past 3 month
                      </MenuItem>
                      <MenuItem
                        sx={styledMenuItem}
                        value="Past_1_Year"
                        disableRipple
                      >
                        Past 1 year
                      </MenuItem>
                      <MenuItem
                        sx={{
                          border: '1px solid #E4E7EB',
                          backgroundColor: colorPrimary,
                          marginX: 1,
                          borderRadius: 3,
                          fontWeight: 700,
                          justifyContent: 'center',
                          marginY: 1,
                          '&:hover': {
                            background: colorPrimary
                          }
                        }}
                        onClick={() => {
                          if (tempDateFilter.dateType) {
                            setChart1Payload({
                              ...chart1Payload,
                              dateType: tempDateFilter.dateType,
                              startDate: tempDateFilter.startDate,
                              endDate: tempDateFilter.endDate
                            });
                          }
                          setTempDateFilter({
                            dateType: null,
                            endDate: null,
                            startDate: null
                          });
                          setOpen(null);
                        }}
                      >
                        Apply
                      </MenuItem>
                      <MenuItem
                        // disabled={
                        //   !(tempDateFilter.dateType || chart1Payload.dateFilter)
                        // }
                        sx={{
                          border: '1px solid #E4E7EB',
                          backgroundColor: colorPrimary,
                          marginX: 1,
                          borderRadius: 3,
                          fontWeight: 700,
                          justifyContent: 'center',
                          marginY: 1,
                          '&:hover': {
                            background: colorPrimary
                          }
                        }}
                        onClick={() => {
                          setChart1Payload({
                            ...chart1Payload,
                            dateType: 'all',
                            startDate: null,
                            endDate: null
                          });
                          setTempDateFilter({
                            startDate: null,
                            dateType: null,
                            endDate: null
                          });
                          setOpen(null);
                        }}
                      >
                        Close
                      </MenuItem>
                    </StyledSelect>
                  </FormControl>
                </Box>
              </Box>
              <Grid item sx={{ display: 'flex', alignSelf: 'end' }}>
                <Tooltip title="Resize">
                  <IconButton
                    onClick={() => handleClickOpen(1)}
                    sx={{ mx: 0.5 }}
                  >
                    <SvgIcon sx={{ height: 20, width: 20 }}>
                      <Expand05Icon />
                    </SvgIcon>
                  </IconButton>{' '}
                </Tooltip>
                <Tooltip title="Download image">
                  <IconButton
                    onClick={() => {
                      handleDownload({ id: 1 });
                    }}
                    sx={{ mr: 0.5 }}
                  >
                    <SvgIcon sx={{ height: 20, width: 20 }}>
                      <FileDownload03Icon />
                    </SvgIcon>
                  </IconButton>
                </Tooltip>
                <Tooltip title="Share">
                  <IconButton onClick={e => handleShareClick(e, 1)}>
                    <SvgIcon sx={{ height: 20, width: 20 }}>
                      <ShareThreeDotsIcon />
                    </SvgIcon>
                  </IconButton>{' '}
                </Tooltip>

                <Menu
                  anchorEl={anchorEl.anchor}
                  open={Boolean(anchorEl.id == 1)}
                  onClose={handleShareClose}
                  onClick={handleShareClose}
                >
                  <MenuItem onClick={() => handleCopyLink(1)}>
                    <SvgIcon fontSize="small" sx={{ marginRight: 2 }}>
                      <Copy05Icon />
                    </SvgIcon>{' '}
                    Copy link
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
            <div id="chart-container-1" style={{ padding: 10 }}>
              <>
                <Legend
                  series={seriesNames.map((name, index) => ({
                    name,
                    color: colors[index],
                    isVisible: visibleSeries[index],
                    onClick: () => toggleSeries(index)
                  }))}
                />
                <Grid item xs={12}>
                  {isContentAnalyticsLoading && (
                    <Skeleton height={300} width={'100%'} />
                  )}
                  {!isContentAnalyticsLoading && (
                    <Chart
                      height={'300px'}
                      width={'100%'}
                      chartType="LineChart"
                      data={contentAnalyticsData.analyticsData}
                      options={options}
                      getChartWrapper={val => {
                        setChart1(val);
                      }}
                    />
                  )}{' '}
                </Grid>
              </>
            </div>
          </Grid>

          {/* List content */}
          <Grid
            mt={2}
            container
            display={'flex'}
            width={'100%'}
            flexDirection={'column'}
            sx={{ borderRadius: '8px', padding: 2, bgcolor: 'white' }}
          >
            <CustomDataTable
              columns={columnUsers}
              allowHover={false}
              defaultOrderBy={'createdDate'}
              data={
                contentAnalyticsLogData?.logData.length > 0
                  ? contentAnalyticsLogData?.logData
                  : []
              }
              onPageChange={val => {
                setContentByIdPayload({ ...contentByIdPayload, page: val });
              }}
              onRowsPerPageChange={val => {
                setContentByIdPayload({ ...contentByIdPayload, size: val });
              }}
              defaultPage={contentByIdPayload.page}
              defaultRowsPerPage={contentByIdPayload.size}
              totalCount={contentAnalyticsLogData?.totalCount ?? 0}
              // onRowClick={row => handleOnRowClick(row)}
            />
          </Grid>
        </>
      )}
      {/* Show chart dialogue in full screen */}
      <Dialog
        sx={{ borderRadius: '8px' }}
        open={chart !== ''}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent sx={{ borderRadius: 10 }}>
          <Box textAlign={'end'}>
            <IconButton size="small" onClick={handleClose}>
              <SvgIcon sx={{ height: 20, width: 20 }}>
                <XClose />
              </SvgIcon>
            </IconButton>
            {/* <Legend
              series={
                contentAnalyticsData.analyticsData.length > 0
                  ? contentAnalyticsData.analyticsData[0]
                      .slice(1)
                      .map((name, index) => ({
                        name,
                        color: options.series[index].color
                      }))
                  : []
              }
            /> */}
            <Legend
              series={seriesNames.map((name, index) => ({
                name,
                color: colors[index],
                isVisible: visibleSeries[index],
                onClick: () => toggleSeries(index)
              }))}
            />
          </Box>
          {chart == 1 && (
            <Chart
              height={'60vh'}
              width={'100%'}
              chartType="LineChart"
              data={contentAnalyticsData.analyticsData}
              options={options}
            />
          )}
        </DialogContent>
      </Dialog>{' '}
      {copySuccess && <SnackBarBox message="Link copied!" type={'success'} />}{' '}
    </>
  );
};

export default ContentAnalytics;

export const Legend = ({ series = [] }) => {
  return (
    <Grid display="flex" spacing={1} justifyContent="end" width="100%">
      {series.map((item, index) => (
        <Grid
          item
          key={index}
          sx={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            opacity: item.isVisible ? 1 : 0.5,
            '&:hover': { opacity: 0.8 }
          }}
          onClick={item.onClick}
        >
          <Avatar
            sx={{
              width: '10px',
              height: '10px',
              backgroundColor: item.isVisible ? item.color : '#ccc',
              marginRight: '8px'
            }}
          >
            <></>
          </Avatar>
          <Typography
            sx={{ fontWeight: '600', color: '#4E565F', fontSize: '14px' }}
          >
            {item.name}
          </Typography>
          {index < series.length - 1 && (
            <Box
              component="span"
              sx={{
                marginX: '8px',
                height: '16px',
                width: '1px',
                backgroundColor: '#E4E7EB',
                display: 'inline-block'
              }}
            />
          )}
        </Grid>
      ))}
    </Grid>
  );
};
